import { useAppSelector } from '@hooks/statehooks';
import {
  createQuotation,
  startOrder as startOrderService,
} from '@services/orderservice';
import { saveQuote } from '@services/showroomservice';
import { PricingType, QuotationResponseType } from '../enums';
import {
  StartOrderRequest,
  QuotationRequest,
  SaveQuoteRequest,
  StartOrderResponse,
} from 'type';

export const useOrder = () => {
  const { vehicleSearchParams, finalisedOptions, vehicleInformation } =
    useAppSelector((state) => state);

  const getSelectedOptions = (): number[] => {
    let rtnVal: number[] = [];

    finalisedOptions.options.forEach((e) => {
      e.items.filter((f) => f.checked).map((m) => rtnVal.push(m.id));
    });

    finalisedOptions.colours.paint
      .filter((f) => f.checked)
      .map((m) => rtnVal.push(m.id));

    finalisedOptions.colours.trim
      .filter((f) => f.checked)
      .map((m) => rtnVal.push(m.id));

    finalisedOptions.colours.hood
      .filter((f) => f.checked)
      .map((m) => rtnVal.push(m.id));

    return rtnVal;
  };

  const getQuotationRequest = (intent: string): QuotationRequest => {
    return {
      vehicleId: vehicleSearchParams.id,
      intent: intent,
      selectedOptions: getSelectedOptions(),
      isUsedVehicle: false,
      calculationParameters: {
        initialPayment: vehicleSearchParams.initial_payment,
        annualMileage: vehicleSearchParams.yearly_mileage,
        duration: vehicleSearchParams.duration,
        includeMaintenance: vehicleSearchParams.include_maintenance,
      },
      isBCHQuote: vehicleInformation.pricingType === PricingType.Business,
    } as QuotationRequest;
  };

  const saveToShowroom = () => {
    return new Promise((resolve, reject) => {
      createQuotation(getQuotationRequest('saveQuote'))
        .then((quoteId: number) => {
          saveQuote({ quoteId: quoteId } as SaveQuoteRequest)
            .then((result: QuotationResponseType) => {
              resolve(result);
            })
            .catch((err: QuotationResponseType) => {
              reject(err);
            });
        })
        .catch((err: QuotationResponseType) => {
          reject(err);
        });
    });
  };

  const getStartOrderRequest = (): StartOrderRequest => {
    return {
      vehicleId: vehicleSearchParams.id,
      annualMileage: vehicleSearchParams.yearly_mileage,
      duration: vehicleSearchParams.duration,
      includeMaintenance: vehicleSearchParams.include_maintenance,
      initialPayment: vehicleSearchParams.initial_payment,
      selectedOptions: getSelectedOptions(),
      isBusinessOrder: vehicleInformation.pricingType === PricingType.Business,
    } as StartOrderRequest;
  };

  const startOrder = () => {
    return new Promise((resolve, reject) => {
      startOrderService(getStartOrderRequest())
        .then((result: StartOrderResponse) => {
          resolve(result);
        })
        .catch((err: QuotationResponseType) => {
          reject(err);
        });
    });
  };

  return { saveToShowroom, startOrder };
};
